module.exports = __webpack_public_path__ + "img/emt-logo_small2.9a644132.png";